/**
 * Search Tracker + Back in Stock — onautica.com
 * Traccia tutte le ricerche e mostra popup "Avvisami" quando 0 risultati.
 */
(function() {
  'use strict';

  var TRACKER_URL = 'https://script.google.com/macros/s/AKfycbwI8NHgcp7BTMXML82WnV85lAw7u5tmD-vod3Ftt3amN0XM3D_NHBXn7FbIDdw8c1xZ/exec';
  var DEBOUNCE_MS = 3000;
  var LOW_RESULTS_THRESHOLD = 3; // Mostra popup se risultati < questo valore
  var lastTracked = '';
  var lastTrackedTime = 0;

  // ─── 1. TRACCIA RICERCHE DALLA PAGINA RISULTATI ───

  function trackFromSearchPage() {
    // Siamo su /search?q=...
    if (window.location.pathname !== '/search') return;

    // Escludi admin (loggato su Shopify — ha la barra admin o il cookie)
    if (document.querySelector('#shopify-section-admin-bar, #admin-bar-iframe, .shopify-preview-bar') ||
        document.cookie.indexOf('_shopify_s') > -1 && document.querySelector('[data-shopify-buttoncontainer]')) {
      return;
    }

    var params = new URLSearchParams(window.location.search);
    // Se la ricerca e stata riscritta dall'expander (singolare/plurale), la query
    // vera del cliente sta in _q: si registra QUELLA, non la forma tecnica.
    var query = params.get('_q') || params.get('q');
    if (!query || query.trim().length < 2) return;

    // Conta risultati — il tema Athens mette nel title "Ricerca: N risultati trovati per..."
    var resultCount = -1;

    // Metodo 1 (piu affidabile): leggi dal title della pagina
    var titleMatch = document.title.match(/Ricerca:\s*(\d+)\s*risultat/i);
    if (titleMatch) {
      resultCount = parseInt(titleMatch[1]);
    }

    // Metodo 2: cerca contatore nel DOM
    if (resultCount === -1) {
      var countEl = document.querySelector('[data-search-results-count], .search-results-count, .results-count');
      if (countEl) {
        var num = countEl.textContent.match(/\d+/);
        if (num) resultCount = parseInt(num[0]);
      }
    }

    // Metodo 3: conta le product card
    if (resultCount === -1) {
      var cards = document.querySelectorAll('.product-card, .grid-product, [data-product-card], .product-item, .collection-product-card');
      resultCount = cards.length;
    }

    // Metodo 4: verifica "0 risultati" / "nessun risultato"
    if (resultCount === -1) {
      resultCount = 0; // fallback
    }

    // Invia al tracker.
    // La pagina riscritta (_pl=1) e' il SECONDO caricamento della stessa ricerca:
    // la registriamo solo se anche cosi non trova nulla, altrimenti la stessa
    // ricerca verrebbe contata due volte.
    // _plx = ritorno alla query originale dopo un tentativo peggiore: gia registrata.
    // _pc = pagina della forma canonica (singolare=plurale, 11/09/2026): e' LA pagina dei
    // risultati, si registra con la query del cliente (_q); la prima pagina, se sta per
    // essere rimandata alla canonica, alza __onauticaCanonRedirect e non registra.
    if (!window.__onauticaCanonRedirect && !params.get('_plx') && !(params.get('_pl') && resultCount > 0)) {
      sendTrack('search', query, resultCount, window.location.href);
    }

    // Se pochi risultati (probabilmente irrilevanti) o 0
    // Ma NON se il banner smart e gia attivo (gestito dal synonym expander)
    if (resultCount < LOW_RESULTS_THRESHOLD && !window.__onauticaSmartBanner) {
      // Mostra popup subito
      showNotifyPopup(query, resultCount);
    }
  }

  // ─── 2. TRACCIA RICERCHE PREDITTIVE (campionamento) ───

  function trackPredictiveSearch() {
    var origFetch = window.fetch;
    window.fetch = function(url, opts) {
      if (typeof url === 'string' && url.indexOf('/search/suggest') !== -1) {
        try {
          var urlObj = new URL(url, window.location.origin);
          var q = urlObj.searchParams.get('q');
          if (q && q.trim().length >= 3) {
            var now = Date.now();
            // Traccia solo se query diversa o dopo debounce
            if (q !== lastTracked || (now - lastTrackedTime) > DEBOUNCE_MS) {
              lastTracked = q;
              lastTrackedTime = now;
              // Non tracciamo le predittive per non sovraccaricare — solo le search page
            }
          }
        } catch(e) {}
      }
      return origFetch.apply(this, arguments);
    };
  }

  // ─── 3. BANNER FISSO "NON HAI TROVATO?" ───

  function showStickyBanner(query, resultCount) {
    var banner = document.createElement('div');
    banner.id = 'onautica-notify-banner';
    banner.style.cssText = 'position:fixed;bottom:0;left:0;width:100%;background:linear-gradient(135deg,#1a56db,#1e40af);color:#fff;padding:14px 20px;z-index:99998;display:flex;align-items:center;justify-content:center;gap:16px;flex-wrap:wrap;box-shadow:0 -4px 20px rgba(0,0,0,0.15);font-family:Arial,sans-serif;';

    var text = resultCount === 0
      ? 'Non abbiamo trovato "' + escapeHtml(query) + '" nel nostro catalogo.'
      : 'Non hai trovato quello che cercavi per "' + escapeHtml(query) + '"?';

    banner.innerHTML = '' +
      '<span style="font-size:15px;">' + text + '</span>' +
      '<button id="onautica-banner-btn" style="background:#fff;color:#1a56db;border:none;padding:10px 24px;border-radius:8px;font-size:14px;font-weight:700;cursor:pointer;white-space:nowrap;transition:transform 0.15s;">Avvisami quando disponibile</button>' +
      '<button onclick="this.parentElement.remove()" style="background:none;border:none;color:rgba(255,255,255,0.7);font-size:20px;cursor:pointer;padding:0 8px;line-height:1;position:absolute;right:12px;top:50%;transform:translateY(-50%);">&times;</button>';

    document.body.appendChild(banner);

    // Il bottone riapre il popup
    document.getElementById('onautica-banner-btn').addEventListener('click', function() {
      // Rimuovi il blocco sessione per permettere di riaprire il popup
      var shownKey = 'onautica_notify_shown_' + query.toLowerCase().trim();
      sessionStorage.removeItem(shownKey);
      showNotifyPopup(query, resultCount);
    });
  }

  // ─── 4. POPUP "AVVISAMI" ───

  function showNotifyPopup(query, resultCount) {
    // Non mostrare se gia mostrato in questa sessione per la stessa query
    var shownKey = 'onautica_notify_shown_' + query.toLowerCase().trim();
    if (sessionStorage.getItem(shownKey)) return;
    sessionStorage.setItem(shownKey, '1');

    // Messaggi diversi per 0 risultati vs pochi risultati
    var titleMsg = resultCount === 0
      ? 'Non abbiamo trovato risultati per:'
      : 'Non hai trovato quello che cercavi?';
    var bodyMsg = resultCount === 0
      ? 'Vuoi essere avvisato quando questo prodotto sara disponibile? Lascia il tuo contatto e ti faremo sapere!'
      : 'I risultati per questa ricerca potrebbero non corrispondere a quello che cerchi. Lasciaci il tuo contatto e ti aiuteremo a trovare il prodotto giusto!';
    var iconEmoji = resultCount === 0 ? '&#128270;' : '&#129300;';

    // Crea overlay
    var overlay = document.createElement('div');
    overlay.id = 'onautica-notify-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:99999;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity 0.3s;';

    var popup = document.createElement('div');
    popup.style.cssText = 'background:#fff;border-radius:16px;padding:32px;max-width:480px;width:90%;box-shadow:0 20px 60px rgba(0,0,0,0.3);position:relative;transform:translateY(20px);transition:transform 0.3s;';

    popup.innerHTML = '' +
      '<button id="onautica-popup-close" style="position:absolute;top:12px;right:16px;background:none;border:none;font-size:24px;cursor:pointer;color:#999;line-height:1;">&times;</button>' +
      '<div style="text-align:center;margin-bottom:20px;">' +
        '<div style="font-size:48px;margin-bottom:8px;">' + iconEmoji + '</div>' +
        '<h3 style="font-size:20px;font-weight:700;color:#111;margin:0 0 8px;">' + titleMsg + '</h3>' +
        '<p style="font-size:18px;color:#1a56db;font-weight:600;margin:0;">"' + escapeHtml(query) + '"</p>' +
      '</div>' +
      '<p style="color:#555;font-size:15px;text-align:center;margin:0 0 20px;">' + bodyMsg + '</p>' +
      '<div id="onautica-notify-form">' +
        '<div style="display:flex;gap:8px;margin-bottom:12px;">' +
          '<button class="onautica-notify-tab" data-type="email" style="flex:1;padding:10px;border:2px solid #1a56db;background:#1a56db;color:#fff;border-radius:8px;cursor:pointer;font-size:14px;font-weight:600;">Email</button>' +
          '<button class="onautica-notify-tab" data-type="whatsapp" style="flex:1;padding:10px;border:2px solid #e5e7eb;background:#fff;color:#333;border-radius:8px;cursor:pointer;font-size:14px;font-weight:600;">WhatsApp</button>' +
        '</div>' +
        '<input type="email" id="onautica-notify-input" placeholder="La tua email..." style="width:100%;padding:14px 16px;border:2px solid #e5e7eb;border-radius:10px;font-size:16px;box-sizing:border-box;outline:none;transition:border-color 0.2s;" onfocus="this.style.borderColor=\'#1a56db\'" onblur="this.style.borderColor=\'#e5e7eb\'">' +
        '<textarea id="onautica-notify-note" placeholder="Note aggiuntive (opzionale)..." style="width:100%;padding:12px 16px;border:2px solid #e5e7eb;border-radius:10px;font-size:14px;box-sizing:border-box;margin-top:8px;height:60px;resize:none;outline:none;" onfocus="this.style.borderColor=\'#1a56db\'" onblur="this.style.borderColor=\'#e5e7eb\'"></textarea>' +
        '<button id="onautica-notify-submit" style="width:100%;padding:14px;background:#1a56db;color:#fff;border:none;border-radius:10px;font-size:16px;font-weight:700;cursor:pointer;margin-top:12px;transition:background 0.2s;" onmouseover="this.style.background=\'#1e40af\'" onmouseout="this.style.background=\'#1a56db\'">Avvisami quando disponibile</button>' +
      '</div>' +
      '<div id="onautica-notify-success" style="display:none;text-align:center;padding:20px 0;">' +
        '<div style="font-size:48px;margin-bottom:12px;">&#9989;</div>' +
        '<h3 style="color:#16a34a;margin:0 0 8px;">Richiesta inviata!</h3>' +
        '<p style="color:#666;font-size:14px;">Ti contatteremo appena il prodotto sara disponibile.</p>' +
      '</div>';

    overlay.appendChild(popup);
    document.body.appendChild(overlay);

    // Animate in
    requestAnimationFrame(function() {
      overlay.style.opacity = '1';
      popup.style.transform = 'translateY(0)';
    });

    // Funzione chiudi popup → mostra banner
    function closePopupShowBanner() {
      overlay.remove();
      if (!document.getElementById('onautica-notify-banner')) {
        showStickyBanner(query, resultCount);
      }
    }

    // Chiudi con X
    popup.querySelector('#onautica-popup-close').addEventListener('click', closePopupShowBanner);

    // Chiudi cliccando fuori
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closePopupShowBanner();
    });

    // Tab email/whatsapp
    var currentType = 'email';
    var tabs = popup.querySelectorAll('.onautica-notify-tab');
    var input = popup.querySelector('#onautica-notify-input');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        currentType = this.getAttribute('data-type');
        tabs.forEach(function(t) {
          t.style.background = '#fff';
          t.style.color = '#333';
          t.style.borderColor = '#e5e7eb';
        });
        this.style.background = '#1a56db';
        this.style.color = '#fff';
        this.style.borderColor = '#1a56db';

        if (currentType === 'whatsapp') {
          input.type = 'tel';
          input.placeholder = 'Il tuo numero WhatsApp...';
        } else {
          input.type = 'email';
          input.placeholder = 'La tua email...';
        }
      });
    });

    // Submit
    popup.querySelector('#onautica-notify-submit').addEventListener('click', function() {
      var contact = input.value.trim();
      var note = popup.querySelector('#onautica-notify-note').value.trim();

      if (!contact) {
        input.style.borderColor = '#dc2626';
        input.focus();
        return;
      }

      // Validazione base
      if (currentType === 'email' && contact.indexOf('@') === -1) {
        input.style.borderColor = '#dc2626';
        input.focus();
        return;
      }

      // Invia
      sendTrack('notify_request', query, 0, '', contact, currentType, note);

      // Mostra successo
      popup.querySelector('#onautica-notify-form').style.display = 'none';
      popup.querySelector('#onautica-notify-success').style.display = 'block';

      // Chiudi dopo 3 secondi
      setTimeout(function() { overlay.remove(); }, 3000);
    });
  }

  // ─── 4. INVIO DATI ───

  function sendTrack(type, query, results, page, contact, contactType, note) {
    var payload = {
      type: type,
      query: query,
      results: results,
      page: page || '',
      date: new Date().toISOString().split('T')[0]
    };
    if (contact) payload.contact = contact;
    if (contactType) payload.contactType = contactType;
    if (note) payload.note = note;

    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(TRACKER_URL, JSON.stringify(payload));
      } else {
        fetch(TRACKER_URL, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify(payload)
        });
      }
    } catch(e) {}
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // ─── INIT ───

  // Traccia dalla search page
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackFromSearchPage);
  } else {
    trackFromSearchPage();
  }

  // Setup intercettazione predittive (per futuro uso)
  trackPredictiveSearch();

  console.log('[Onautica] Search Tracker attivo');
})();
